<div class="row">
  <app-summary-scales-chart class="col" 
    [showNames]="false" 
    [scaleResults]="[summaryScaleResult]"></app-summary-scales-chart>
</div>
<div class="row">
  <div class="col text-center criteriaContainer mt-1" 
    [ngClass]="{'checked': criteria.hasPTSD}" *ngFor="let criteria of Criteria"
    (click)="goToScaleResult(criteria.scaleResult)">
    <pcl-criteria-icon [criteria]="criteria.name" [checked]="criteria.hasPTSD"></pcl-criteria-icon>
    <div class='text-center'>
      <h4 class="h4-responsive mb-0" 
        [ngClass]="{'color-red': criteria.hasPTSD, 'color-green': !criteria.hasPTSD}">
        <i *ngIf="!criteria.hasPTSD" class="fa fa-check-circle"></i>
      </h4>
      <h4 class="h4-responsive mb-0"
        [ngClass]="{'color-red': criteria.hasPTSD, 'color-green': !criteria.hasPTSD}">
        <i *ngIf="criteria.hasPTSD" class="fa fa-remove"></i>
      </h4>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/reports/pcl-summary/pcl-summary.component.html